var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "StoneCutAsscher",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-stone-cut-asscher","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M219.7-.5H32.8L1 32.7v184.8l34.9 32h182.8l30.8-32.7V29.6L219.7-.5zm2.6 45.7l-17.6-18.3 13.2-16.4 21.7 21.9-17.3 12.8zM179 80.4v89l-11 12.5H86l-12.7-12.4V80.9l11.5-12.8h83.8l9.3 10-.3.2 1.4 2.1zm-11.9-21.3H83.7l-7.2-9h97.9l-7.3 9zm-90.9 5l-9.3 10.3-11-8.2 11.8-12.8 8.5 10.7zm-12 19.6v83.2l-9.2 6.9v-97l9.2 6.9zm2.9 92.3l10.1 9.8-7.6 9.5-12.5-11.9 10-7.4zm17.5 14.9h83.7l5.8 7.2H78.8l5.8-7.2zm91.5-4.7l8.9-10 9.7 7.2-11 12.2-7.6-9.4zm11.9-18.9V81.8l8.5-6.3v98.1l-8.5-6.3zm-2.9-94.5l-9.3-10 8.3-10.4 11.8 12.4-10.8 8zm-3.5-31.7H69.3L61.2 31h128.6l-8.2 10.1zM62 46.4L48.6 60.9l-12.3-9.1 16.1-17.3L62 46.4zM46 70.2v110.3l-10.8 8V62.1L46 70.2zm3.7 118.7l14.2 13.5-9.6 11.9-17.1-16.1 12.5-9.3zm21.9 18.2h109.7l8.4 10.5H63.2l8.4-10.5zm117.7-4.4l12.6-13.9 11.7 8.7-15.1 16.6-9.2-11.4zm16.2-22.4V68.8l9.5-7.1v125.5l-9.5-6.9zm-2.3-121l-13.4-14 9.1-11.4 16 16.7-11.7 8.7zM197 22H54L43.1 8.5h164.7L197 22zM46.7 27.4L29 46.4 12.3 33.9l21.6-22.5 12.8 16zM26.2 55.5v139.7l-16.2 12V43.4l16.2 12.1zm3.7 148.1l18.7 17.7-12.8 15.9-22.9-21 17-12.6zm26 23h141l11.2 13.9H44.8l11.1-13.9zm148.3-5.4l16.7-18.3 17.3 12.8-20.7 22-13.3-16.5zM224 194V55.1l16.5-12.2v163.4L224 194z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/stone-cut-asscher.svg